import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';
import { DATA_TYPE, CHANNELS_FILTER_TRANSLATE } from '@/store/modules/cards/constants';

const dataTypesWithBasicFilter = [
  DATA_TYPE.SAC,
  DATA_TYPE.PAGE,
  DATA_TYPE.SAC_STATUS,
  DATA_TYPE.BLIP,
];

function getUsedFilterList(getters, dataType, filterType = undefined) {
  return dataType === DATA_TYPE.SAC_LISTENING
    ? cloneDeep(getters.filterByDataType[filterType])
    : cloneDeep(getters.filterByDataType[dataType]);
}

function getCardFilter(filter, dataType, filterType = undefined) {
  if (dataType === DATA_TYPE.SAC_LISTENING) {
    if (filterType === DATA_TYPE.SAC) {
      return { ...filter?.sacFilter };
    }
    return { ...filter?.listeningFilter };
  }

  return { ...filter };
}

export async function applyGlobalFilter({ getters, dispatch }, options = {}) {
  const { card, filterType } = options;
  const filter = card.props.filter;

  const dataType = card.dataType;
  const usedFilterList = getUsedFilterList(getters, dataType, filterType);
  const cardFilters = getCardFilter(filter, dataType, filterType);

  const channelsToFilter = [];

  if (card?.control && usedFilterList.channels) {
    Object.entries(card.control).forEach((data) => {
      if (data[0] in CHANNELS_FILTER_TRANSLATE && Boolean(data[1]?.hideInChannel)) {
        channelsToFilter.push(CHANNELS_FILTER_TRANSLATE[data[0]]);
        usedFilterList.channels.value = usedFilterList.channels.value.filter((data) =>
          !channelsToFilter.includes(data)
        );
      }
    });
  }

  Object.keys(cardFilters)
    .forEach((filter) => {
      if (usedFilterList[filter]) {
        delete usedFilterList[filter];
      }
    });
  let basicCardFilters = {};

  if (dataTypesWithBasicFilter.includes(card.dataType)) {
    basicCardFilters = await dispatch('dashboard/populateBasicFilter', cardFilters, { root: true });
  }

  return merge({}, basicCardFilters, usedFilterList, cardFilters);
}
